import React from 'react';
import {
  Card,
  Checkbox,
  ConfigProvider,
  Divider,
  Radio,
  Space,
  Table,
  Tag,
  Typography,
} from 'antd';
import { GESTIONES_LABELS } from '../exportacion/cotizacionFinalForm';
import './serviciosAcordadosVista.css';

const { Text } = Typography;

const CheckboxReadonly = ({ checked, children }) => (
  <Checkbox disabled checked={checked}>
    {children}
  </Checkbox>
);

const colsDocReadonly = () => [
  {
    title: 'Concepto',
    dataIndex: 'label',
    width: 260,
    render: (t) => <Text strong>{t}</Text>,
  },
  {
    title: 'SI',
    width: 56,
    align: 'center',
    render: (_, row) => <CheckboxReadonly checked={!!row.si} />,
  },
  {
    title: 'NO',
    width: 56,
    align: 'center',
    render: (_, row) => <CheckboxReadonly checked={!!row.no} />,
  },
  {
    title: 'Comentarios',
    dataIndex: 'comentarios',
    render: (v) => (v && String(v).trim() ? String(v) : '—'),
  },
];

const colsAtaReadonly = () => [
  {
    title: 'Concepto',
    dataIndex: 'label',
    width: 260,
    render: (t) => <Text strong>{t}</Text>,
  },
  {
    title: 'SI',
    width: 56,
    align: 'center',
    render: (_, row) => <CheckboxReadonly checked={!!row.si} />,
  },
  {
    title: 'NO',
    width: 56,
    align: 'center',
    render: (_, row) => <CheckboxReadonly checked={!!row.no} />,
  },
];

const MENSAJES_SIN_SERVICIOS = {
  no_aprobada: 'La cotización debe estar aprobada para tener servicios acordados guardados.',
  sin_guardar: 'Esta cotización aún no tiene servicios acordados guardados (cotización final).',
  no_encontrada: 'No se encontró la cotización final.',
};

const ServiciosAcordadosVista = ({ form, productos = [], motivoSinServicios = null }) => {
  if (!form) return null;

  const tablasDisabled = form.tipoOperacion === 'IMPORTACION';

  return (
    <div className="servicios-acordados-readonly">
    <Space direction="vertical" size="middle" style={{ width: '100%' }}>
      {(productos || []).length > 0 ? (
        <Card size="small" title="Productos" style={{ borderColor: '#d8e8dc' }}>
          <Space direction="vertical" size="small" style={{ width: '100%' }}>
            {productos.map((p) => (
              <div key={p.id ?? p.productoId}>
                <Text strong>{p.productoNombre || '—'}</Text>
                {p.posicionArancelaria ? (
                  <div>
                    <Text type="secondary">Posición arancelaria: {p.posicionArancelaria}</Text>
                  </div>
                ) : null}
              </div>
            ))}
          </Space>
        </Card>
      ) : null}

      {motivoSinServicios ? (
        <Text type="secondary">{MENSAJES_SIN_SERVICIOS[motivoSinServicios] || ''}</Text>
      ) : null}

      <Card size="small" title="Gestiones solicitadas por el cliente" style={{ borderColor: '#d8e8dc' }}>
        <Space direction="vertical" size="small">
          {GESTIONES_LABELS.map(([key, label]) => (
            <CheckboxReadonly key={key} checked={!!form.gestiones?.[key]}>
              {label}
            </CheckboxReadonly>
          ))}
        </Space>
      </Card>

      <Card size="small" title="Servicios acordados" style={{ borderColor: '#d8e8dc' }}>
        <Text strong style={{ display: 'block', marginBottom: 8 }}>
          Operación
        </Text>
        <ConfigProvider
          theme={{
            token: { colorPrimary: '#198039' },
            components: {
              Radio: {
                buttonBg: '#ffffff',
                buttonCheckedBg: '#f0faf2',
                buttonCheckedColor: '#198039',
                buttonCheckedBorderColor: '#198039',
                buttonColor: 'rgba(0,0,0,0.88)',
                colorBorder: '#d9d9d9',
              },
            },
          }}
        >
          <Radio.Group
            optionType="button"
            buttonStyle="outline"
            disabled
            value={form.tipoOperacion ?? 'EXPORTACION'}
          >
            <Radio.Button value="IMPORTACION">Importación</Radio.Button>
            <Radio.Button value="EXPORTACION">Exportación</Radio.Button>
          </Radio.Group>
        </ConfigProvider>
        {tablasDisabled ? (
          <div style={{ marginTop: 12 }}>
            <Tag color="blue">Importación</Tag>
            <Text type="secondary" style={{ marginLeft: 8 }}>
              Las tablas de servicios no aplican para operaciones de importación.
            </Text>
          </div>
        ) : (
          <>
            <Divider />
            <Text strong>Sector documentación comercial</Text>
            <Table
              size="small"
              pagination={false}
              rowKey="key"
              columns={colsDocReadonly()}
              dataSource={form.sectorDocComercial || []}
              scroll={{ x: 600 }}
            />
            <Divider />
            <Text strong>Otros conceptos a cobrar</Text>
            <Table
              size="small"
              pagination={false}
              rowKey="key"
              columns={colsDocReadonly()}
              dataSource={form.otrosConceptos || []}
              scroll={{ x: 600 }}
            />
            <Divider />
            <Text strong>Servicio ATA</Text>
            <Table
              size="small"
              pagination={false}
              rowKey="key"
              columns={colsAtaReadonly()}
              dataSource={form.servicioAta || []}
              scroll={{ x: 500 }}
            />
          </>
        )}
      </Card>
    </Space>
    </div>
  );
};

export default ServiciosAcordadosVista;
